(function () {
  'use strict';

  angular
    .module('app.components', []);
})();
